import PropTypes from 'prop-types';
import Image from 'next/image';

// Styles
import styles from './ContactLayout.module.css';

function ContactLayout({
  title, content, children, imgSrc,
}) {
  return (
    <div className={styles.layout}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        {content ? <p className={styles.content}>{content}</p> : null}
        {children}
      </div>
      <div className={styles.sideImage}>
        <Image
          priority
          className={styles.image}
          src={imgSrc}
          fill
          alt="contact picture"
          sizes="(max-width: 1024px) 100vw,
                                      50vw"
        />
      </div>
    </div>
  );
}

ContactLayout.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  children: PropTypes.node,
  imgSrc: PropTypes.string,
};

ContactLayout.defaultProps = {
  title: '',
  content: '',
  children: null,
  imgSrc: '',
};

export default ContactLayout;
